import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { TreatmentEntity } from 'src/app/core/interfaces/treatment-entity';
import { Router } from '@angular/router';
import { FindTimeService } from 'src/app/core/services/find-time.service';
import { TreatmentType } from 'src/app/core/enums';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { AppData } from 'src/app/app.data';


@Component({
  selector: 'app-treatment-row',
  templateUrl: './treatment-row.component.html',
  styleUrls: ['./treatment-row.component.scss']
})
export class TreatmentRowComponent implements OnInit {

  @Input() treatmentType: TreatmentType;
  @Input() treatment: TreatmentEntity;
  @Input() odd: boolean;
  @Input() even: boolean;
  @Input() canChangePrice: boolean;
  showDescription = false;


  constructor(
    private router: Router, 
    private findTimeService: FindTimeService, 
    private appData: AppData, 
    private cd: ChangeDetectorRef) { }

  ngOnInit() {
    this.treatment.Selected = this.appData.treatmentsContains(this.treatment.ID);
    this.canChangePrice = this.appData.appointment == null; // cannot change price on moving event only new appointments
    console.log(this.treatmentType);
  }

  onSelect(event) {
    this.appData.treatments = [this.treatment];
    this.router.navigate(['/find-time']);
  }

  onChange(event: MatCheckboxChange) {
    if (event.checked) {
      this.treatment.Selected = true;
      this.appData.addToTreatments(this.treatment);
    } else {
      this.treatment.Selected = false;
      this.appData.removeFromTreatments(this.treatment.ID);
    }
  }

  onChangePrice(event) {

    var newPrice = parseFloat(event.target.value || '0');
    var shouldRefreshDom = false;
    if (isNaN(newPrice) || newPrice < 0) {
      newPrice = 0;
      shouldRefreshDom = true;
    }
    
    // prevent less then total paid
    if (this.treatment.TotalPaid > 0 && newPrice < this.treatment.TotalPaid) { 
      newPrice = this.treatment.TotalPaid;
      shouldRefreshDom = true;      
    }      

    // set the new price
    this.treatment.Price = newPrice;

    // if selected update the saved item
    if (this.appData.treatmentsContains(this.treatment.ID)) {
      this.appData.removeFromTreatments(this.treatment.ID);
      this.appData.addToTreatments(this.treatment);
    }

    if(shouldRefreshDom){
      this.cd.detectChanges();
    }
   
  }

  isSeries(): boolean {
    return this.treatmentType === TreatmentType.Series;
  }
}
